import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

export default function AboutUsPage({setToken}) {
  const [firstTime, setFirstTime] = useState(true);
  const [isMobile, loading] = useOutletContext();

  useEffect(() => {
    if(firstTime)
    {
      
    }
    setFirstTime(false);
  }, [firstTime]);

  return (
    <>
        <Stack alignContent={"center"} style={{padding: "0 2rem"}}>
            <div style={{textAlign: "center"}}>
              <h2><b>CHI SIAMO</b></h2>
              <div style={{margin: "auto", textAlign: "left", width: "90%"}}>
              <h4><u>Una gloriosa storia</u></h4>
              Della nostra sala cinematografica si potrebbero raccontare e descrivere molti e diversi aneddoti di situazioni e problematiche affrontate nel corso degli anni. Ma potremmo incorrere in errori di presentazione o prospettiva degli stessi. Per questo crediamo che la cronistoria degli avvenimenti possa essere sufficientemente esaustiva di quanto lavoro e dedizione l'attuale sala ha goduto negli anni e della fortuna di cui godiamo, noi frequentatori odierni.
              
              <h4><u>1961 – Marzo (Edificazione e avvio)</u></h4>
              Don Vigilio Marini, nel suo quinto anniversario da Caffarese, decise di donare al paese una sala cinematografica, utilizzando fondi derivanti esclusivamente dalla eredità paterna.<br/><br/>
              Il 20 marzo 1961 venne posata la prima pietra della costruzione che ospiterà il futuro Cinema di Ponte Caffaro.

              <h4><u>1961 – Ottobre (L' inaugurazione)</u></h4>
              Nell' ottobre del 1961 il Cinema Aurora viene inaugurato con la proiezione del film 'La schiava di Roma', un autentico colossal per allora.<br/><br/>
              La novità e il seguito popolare che ebbe permisero alla struttura di attraversare un lungo periodo di intensa e seguitissima programmazione.

              <h4><u>Anno 1980 (Il rinnovamento)</u></h4>
              Dopo un periodo di lento e graduale declino, dovuto in parte all'avvento della televisione, la Pro Loco decise di ravvivare la programmazione con titoli innovativi che richiesero anche l'acquisto di due nuove macchine da proiezione a recuperare il gap tecnico e poter passare a proiezioni di pellicole a passo normale.<br/><br/>
              Furono contemporaneamente effettuati degli interventi strutturali di adeguamento alla cambiata normativa in materia di sicurezza.<br/><br/>
              L'investimento complessivo fu di circa settanta milioni di lire: una bella cifra per l'epoca.<br/><br/>
              L' attività della sala riprese quota e diventò praticamente l'unica sala funzionante della zona.

              <h4><u>1998 La conversione (I lavori)</u></h4>
              A distanza di 37 anni dalla sua costruzione si procede ad una doverosa quanto necessaria, completa ristrutturazione interna. I lavori di ristrutturazione riguarderanno tutta la struttura: a partire dal rifacimento degli impianti elettrico e termico. L' installazione di un nuovo e più performante impianto audio. Il rifacimento dei servizi igienici, dell'ingresso e della zona bar e all' abbattimento delle barriere architettoniche. Non da ultimi il rinnovo dell'arredo e a diverse opere di finitura.
              5 dicembre 1998<br/><br/>
              Il 5 dicembre del 1998 viene inaugurato il Nuovo Cinema Aurora.<br/><br/>
              Nuovi impianti e finiture, 223 comodi posti a sedere, sistema Dolby Surround. Trecentocinquanta milioni di spesa.

              <h4><u>2023</u></h4>
              Dopo più di 60 anni di gloriosa storia, attualmente si alternano circa una decina di volontari per continuare con dedizione e passione a gestire questo punto di riferimento per la nostra comunità.<br/><br/>
              Un sentito ringraziamento a tutti quelli che hanno reso possibile questo traguardo.
              <br/><br/>
              <h4>Il team del Cinema Aurora</h4>
              </div><br/>
              <div style={{margin: "auto", textAlign: "-webkit-center", width: "90%"}}>
              <img style={{width: isMobile ? "100%" : "80%"}} src={`${process.env.PUBLIC_URL}/images/services/cinema_1.jpg`}/>
              </div>
            </div>
            
          </Stack>
    </>
  );
}
